export default __webpack_public_path__ + "static/media/te-avan-angular.393ee3f4.png";